import { render, staticRenderFns } from "./PensionContractAliquotsTable.vue?vue&type=template&id=2df279a2&"
import script from "./PensionContractAliquotsTable.vue?vue&type=script&lang=ts&"
export * from "./PensionContractAliquotsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PensionContractAliquotsTable.vue?vue&type=style&index=0&id=2df279a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports